import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@material-ui/core";
import { useSnackbar } from 'notistack';
import React from 'react';
import Page from "../../containers/Page/Page";
import { api } from '../../services/api';
import { Helpers } from '../../utils/Helpers';

interface ISubtipo {
    id: string;
    subtipo: string;
    ordem: string;
}

function Subtipos() {

    const { enqueueSnackbar: alert } = useSnackbar();

    const [error, setError] = React.useState<string>('');
    const [loading, setLoading] = React.useState<boolean>(false);
    const [subtipo, setSubtipo] = React.useState<string>('');
    const [subtipos, setSubtipos] = React.useState<ISubtipo[]>([]);
    const [createDialog, setCreateDialog] = React.useState<boolean>(false);
    const [createLoading, setCreateLoading] = React.useState<boolean>(false)

    /**
     * Ao carregar a página.
     */
    React.useEffect(() => {
        handleFetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Carregar hierarquia.
     * @param page 
     */
    async function handleFetch(load = true) {
        setLoading(load);
        try {
            const response = await api.get('hierarquia');
            setSubtipos(response.data.object);
            setError('');
        } catch (error: any) {
            setError(Helpers.errorFormat(error));
        }
        setLoading(false);
    }

    async function handleSave() {
        setCreateLoading(true);
        try {
            const response = await api.post('hierarquia', {
                subtipo: subtipo
            });
            await handleFetch(false);
            alert(response.data.message, { variant: 'success' });
        } catch (error) {
            Helpers.error(error, alert);
        }
        setCreateLoading(false);
        setCreateDialog(false);
        setSubtipo('');
    }

    async function handleChange(item: ISubtipo, value: string) {
        try {
            const response = await api.put(`hierarquia/${item.id}`, {
                subtipo: item.subtipo,
                ordem: value
            });
            await handleFetch(false);
            alert(response.data.message, { variant: 'success' });
        } catch (error) {
            Helpers.error(error, alert);
        }
    }

    return (
        <Page error={error} loading={loading}>
            <Page.Title>
                <Typography variant="h6" component="div">
                    Subtipos
                </Typography>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={() => setCreateDialog(true)}>
                    Novo Subtipo
                </Button>
                <Dialog fullWidth={true} maxWidth="xs" open={createDialog} onClose={() => setCreateDialog(false)}>
                    <DialogTitle>Novo Subtipo</DialogTitle>
                    <DialogContent>
                        <TextField
                            margin="dense"
                            label="Nome do Subtipo"
                            autoFocus={true}
                            fullWidth={true}
                            value={subtipo}
                            onChange={(event) => setSubtipo(event.target.value)}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            color="primary"
                            disabled={createLoading}
                            onClick={() => setCreateDialog(false)}>
                            Cancelar
                        </Button>
                        <Button
                            color="primary"
                            startIcon={createLoading ? <CircularProgress color="inherit" size="15px" /> : undefined}
                            disabled={createLoading}
                            onClick={() => handleSave()}>
                            Adicionar
                        </Button>
                    </DialogActions>
                </Dialog>
            </Page.Title>
            {subtipos &&
                <Page.Section>
                    <Page.Content>
                        <TableContainer>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Ordem</TableCell>
                                        <TableCell>Subtipo</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {subtipos.map((subtipo, index) => (
                                        <TableRow key={index} hover={true}>
                                            <TableCell width="5%">
                                                <TextField
                                                    margin="dense"
                                                    label=""
                                                    select={true}
                                                    fullWidth={true}
                                                    value={subtipo.ordem}
                                                    onChange={(event) => handleChange(subtipo, event.target.value)}
                                                >
                                                    {subtipos.map((_s, i) => (
                                                        <MenuItem key={i} value={i}>{i + 1}</MenuItem>
                                                    ))}
                                                </TextField>
                                            </TableCell>
                                            <TableCell>{subtipo.subtipo}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Page.Content>
                </Page.Section>
            }
        </Page >
    );
}

export default Subtipos;